import "react-toastify/dist/ReactToastify.css";
import "./my-downloads.css";

import DvrIcon from "@mui/icons-material/Dvr";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import RefreshIcon from "@mui/icons-material/Refresh";

import {
  Button,
  CardContent,
  FormControl,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Stack,
  Tooltip,
} from "@mui/material";
import Chip from "@mui/material/Chip";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import Pagination from "@mui/material/Pagination";
import axios from "axios";
import {
  getToolsubmissions,
  getToolsubmissionsByUser,
  refreshToolSubmission,
} from "../../adapter/ToolAdapter";
import Loader from "../../components/Loader";
import { baseUrl } from "../../variables/variables";

const ITEMS_PER_PAGE = 10;

export default function EnterpriseList() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedToolId, setSelectedToolId] = useState("");
  const [toolNames, setToolNames] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [originalData, setOriginalData] = useState([]); // New state variable to store original data
  const navigate = useNavigate();

  const fetchToolSubmissions = async () => {
    try {
      setLoading(true);
      const response = await getToolsubmissionsByUser();
      setLoading(false);
      if (response.status === "success") {
        setData(response.data);
        setOriginalData(response.data); // Save the original data fetched from the server
        console.log(response.data);
      } else {
        toast.error("Something went wrong!");
        setData([]);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
      toast.error("Something went wrong!");
      setData([]);
    }
  };

  useEffect(() => {
    fetchToolSubmissions();
    fetchToolsData();
  }, []);

  const handleToolSelectChange = (event) => {
    setSelectedToolId(event.target.value);
    setCurrentPage(1); // Reset pagination to page 1
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value.toLowerCase());
  };

  const handleSubmit = () => {
    setCurrentPage(1); // Reset pagination to the first page
    let filteredData = originalData;

    if (selectedToolId) {
      filteredData = filteredData.filter(
        (dataItem) => dataItem.toolId === selectedToolId
      );
    }
    if (searchText) {
      filteredData = filteredData.filter((dataItem) =>
        dataItem.input1?.toLowerCase().includes(searchText)
      );
    }

    setData(filteredData);

    if (filteredData.length === 0) {
      toast.info(
        "No results found. If you want to Search Particular reference id so don't select any Tools only search by Reference Id"
      );
    }
  };

  const fetchToolsData = async () => {
    try {
      const response = await axios.get(baseUrl + "/tools");
      setToolNames(response.data.data);
    } catch (error) {
      console.error("Error fetching tools data:", error);
    }
  };

  const handleDownload = async (id, type) => {
    try {
      const url = baseUrl + "/tool-submissions/" + id + "/" + type;

      // Fetch through the auth shim (which attaches the Bearer token for backend URLs), then
      // download the returned blob. A direct <a href> navigation cannot carry the Authorization
      // header, so it would 401 once enforcement is on.
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(
          `Download failed with status: ${response.status} File not Found !! Please see in the Logs`
        );
      }

      // Use the server-provided filename (Content-Disposition), which carries the correct
      // extension (.zip/.pdf/.xlsx/…). Fall back to id_type only if the header is unavailable.
      const disposition = response.headers.get("Content-Disposition") || "";
      const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';\n]+)/i);
      const filename =
        match && match[1] ? decodeURIComponent(match[1].trim()) : `${id}_${type}`;

      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.setAttribute("download", filename);
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error("Download error:", error); // Log for debugging
      // Display toast error message using your preferred toast library
      toast.error("Failed to download file. Please try again later."); // Example using toast.error()
    }
  };

  function formatCreatedAt(timestamp) {
    const date = new Date(timestamp);
    const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")} ${date
      .getHours()
      .toString()
      .padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}:${date
      .getSeconds()
      .toString()
      .padStart(2, "0")}`;
    return formattedDate;
  }

  const handleRefresh = async (id) => {
    try {
      const response = await refreshToolSubmission(id);
      if (response.status === "success") {
        const index = data.findIndex((item) => item.id === id);
        if (index !== -1) {
          const newData = [...data];
          newData[index] = response.data;
          setData(newData);
          toast.success("Record refreshed successfully");
        } else {
          toast.error("Record not found in the data");
        }
      } else {
        toast.error("Failed to refresh record");
      }
    } catch (error) {
      console.error("Error refreshing record:", error);
      toast.error("Failed to refresh record");
    }
  };





  const getStatusColor = (status) => {
    switch (status) {
      case "success":
        return "success";
      case "failed":
        return "error";
      case "in-progress":
        return "primary";
      default:
        return "default";
    }
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const renderData = data
    ?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE)
    .map((dataItem, index) => (
      <div variant="outlined" className="custom-card" key={index}>
        <CardContent>
          <div className="card-header">
            <div>
              <h4 style={{ display: "inline" }}>
                Reference id : {dataItem.input1}
              </h4>{" "}
              <Chip
                style={{ marginLeft: "5px" }}
                variant="outlined"
                size="small"
                label={dataItem.status}
                color={getStatusColor(dataItem.status)}
              />
              <p className="sub-text" style={{ fontSize: "small" }}>
                <span style={{ fontStyle: "italic" }}>Created by</span>{" "}
                <span style={{ color: "rgb(2, 136, 209)" }}>
                  {dataItem.createdBy}
                </span>{" "}
                <span style={{ fontStyle: "italic" }}>at</span>{" "}
                <span style={{ color: "rgb(2, 136, 209)" }}>
                  {formatCreatedAt(dataItem.createdAt)}
                </span>
              </p>
            </div>
            <Stack direction="row" spacing={2}>
              <Tooltip
                title="Refresh"
                onClick={() => handleRefresh(dataItem.id)}
                sx={{ color: "rgb(0, 81, 134)" }}
              >
                <RefreshIcon />
              </Tooltip>
              <Tooltip
                title="output"
                onClick={() => handleDownload(dataItem.id, "output")}
                sx={{ color: "rgb(0, 81, 134)" }}
              >
                <FileDownloadIcon />
              </Tooltip>
              <Tooltip
                title="Logs"
                onClick={() => handleDownload(dataItem.id, "logs")}
                sx={{ color: "rgb(0, 81, 134)" }}
              >
                <DvrIcon />
              </Tooltip>
            </Stack>
          </div>
          <Paper className="assignemtCards">
            {
              <div>
                <span>ToolName :</span>
                <span className="sub-text">
                  {toolNames.find((tool) => tool.id === dataItem.toolId)
                    ?.name || ""}
                </span>
              </div>
            }
            {dataItem.id && (
              <div>
                <span>Submission Id :</span>
                <span className="sub-text">{dataItem.id.split("-")[4]} </span>
              </div>
            )}
            {dataItem.input1 && (
              <div>
                <span>Input 1st :</span>
                <span className="sub-text">{dataItem.input1}</span>
              </div>
            )}
            {dataItem.input2 && (
              <div>
                <span>Input 2nd :</span>
                <span className="sub-text">{dataItem.input2}</span>
              </div>
            )}
            {dataItem.input3 && (
              <div>
                <span>Input 3rd :</span>
                <span className="sub-text">
                  {dataItem.input3.slice(0, 50)}{" "}
                </span>
              </div>
            )}
            {dataItem.input4 && (
              <div>
                <span>Input 4th :</span>
                <span className="sub-text">
                  {dataItem.input4.slice(0, 50)}{" "}
                </span>
              </div>
            )}
            {dataItem.input5 && (
              <div>
                <span>Input 5th :</span>
                <span className="sub-text">{dataItem.input5}</span>
              </div>
            )}
            {dataItem.input6 && (
              <div>
                <span>Input 6th :</span>
                <span className="sub-text">{dataItem.input6}</span>
              </div>
            )}
          </Paper>
        </CardContent>
      </div>
    ));

  return (
    <>
      <div className="navView">
        <ToastContainer />
        <Loader loading={loading} />
        <div
          className="component-titleContainer"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginLeft: "25px",
          }}
        >
          <h2 className="component-title">Downloads</h2>
        </div>
        <div
         className="download_select"
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            margin: "20px",
          }}
        >
          <FormControl style={{ marginRight: "20px",width:'450px' }}>
            <Select
              value={selectedToolId}
              onChange={handleToolSelectChange}
              displayEmpty
              inputProps={{ "aria-label": "Select Tool" }}
              style={{
                borderRadius: "30px",
                border: "unset",
                background: "#f8f9fb",
                paddingLeft: "10px",
                width: "100%",
              }}
            >
              <MenuItem value="" selected={!selectedToolId}>
                Select Tool
              </MenuItem>
              {Array.isArray(toolNames) &&
                toolNames.map((tool) => (
                  <MenuItem key={tool.id} value={tool.id}>
                    {tool.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <FormControl style={{ marginRight: "10px", minWidth: "280px" }}>
            <OutlinedInput
              style={{
                borderRadius: "30px",
                border: "unset",
                background: "#f8f9fb",
                width: "100%",
              }}
              size="small"
              id="header-search"
              startAdornment={
                <InputAdornment position="start">
                  {/* <SearchOutlined /> */}
                </InputAdornment>
              }
              aria-describedby="header-search-text"
              placeholder="Search by Reference Id"
              inputProps={{ "aria-label": "weight" }}
              value={searchText}
              onChange={handleSearchChange}
            />
          </FormControl>

          <FormControl>
            <Button
              color="secondary"
              fullWidth
              style={{
                background:
                  "linear-gradient(118deg, #005186, rgb(0 81 134 / 81%))",
              }}
              variant="contained"
              onClick={handleSubmit}
            >
              Search
            </Button>
          </FormControl>
        </div>

        {!loading && <div className="assigment_list">{renderData}</div>}
        <div className="paginationNew">
          <Pagination
            count={Math.ceil(data.length / ITEMS_PER_PAGE)}
            page={currentPage}
            onChange={handlePageChange}
            shape="rounded"
          />
        </div>
      </div>
    </>
  );
}
